import React from 'react'
import {connect} from 'react-redux'
import {Toast} from 'react-weui'
import axios from 'axios'
import { Page} from '../components'
import {renderMoney, TimeStream, getJsonFromUrl} from '../utils';
import '../css/page/SuperVipPage.css'
import { Pay } from "../components/index"
import pgy from '../images/superVip/pgy.png'
import { isProduction } from '../config'
class SuperVipChannelList extends React.Component {
    constructor() {
        super();
    }
    render(){
        const {content} = this.props;

        return (
            <a href={`/channel/${content.id}/?from_svip_page=1`} className={"wk-currency-item-svip"}>
                <div className="currency-item-left">
                    <div className="currency-item-img background-image" style={{backgroundImage: `url(${content.cover_url})`}}>
                    </div>
                </div>
                <div className="currency-item-right">
                    <div className="currency-item-right-title">
                        {content.name}
                    </div>
                    <div className="currency-item-right__container">
                        <div className="currency-item-right-bottom">
                            <div className="currency-item-right-bottom_left">
                                <div className="currency-item-right-bottom_left-count-time">
                                    <p>已更新{content.stats_info.lecture_count}期</p>
                                </div>
                            </div>
                            <div className="currency-item-right-bottom_right">
                                <p>
                                    ￥{renderMoney(content.money).split('.')[0]}
                                    <span>.{renderMoney(content.money).split('.')[1]}</span>
                                </p>
                                <buttom>会员免费听</buttom>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        )
    }
}

class OnlyThreeDayPopup extends React.Component{
    constructor(){
        super()
        this.times = null
        this.state = {
            show:true,
            remainingTime:{
                hour:null,
                minute:null,
                second:null,
                millisecond:null
            }
        }
        this.popupHide = this.popupHide.bind(this)
        this.getDeadline = this.getDeadline.bind(this)
        this.downTime = this.downTime.bind(this)
        this.handleClick = this.handleClick.bind(this)
    }
    componentDidMount(){
        this.getDeadline(this.props.expire_timestamp)
    }
    popupHide(){
        this.setState({
            show:false
        })
        this.times && clearInterval(this.times)
    }
    componentWillUnmount(){
        this.times && clearInterval(this.times)
    }
    getDeadline (expire_timestamp) {
        let deadline = expire_timestamp*1000 - new Date().getTime()
        if(deadline > 24*60*60*1000*3 || deadline <= 0) return
        this.downTime(deadline)
        this.times = setInterval(()=>{
            deadline -= 10;
            if(deadline <= 0){
                clearInterval(this.times)
                //关闭弹窗 刷新数据
                this.setState({
                    show:false
                })
                this.props.refreshPage()
                return
            }
            this.downTime(deadline);
        },10)
    }
    downTime(time){
        let hour = Math.floor(time / (60*60*1000))
        let minute = Math.floor((time % (60*60*1000)) / (60*1000))
        let second = Math.floor((time % (60*1000) ) / 1000)
        let millisecond = Math.floor(time%1000)
        hour = hour < 10 ? '0' + hour:hour
        minute = minute < 10 ? '0' + minute:minute
        second = second < 10 ? '0' + second:second
        millisecond = millisecond < 10 ?'0'+millisecond:millisecond.toString().slice(0,2)
        this.setState({
            remainingTime:{
                hour:hour,
                minute:minute,
                second:second,
                millisecond:millisecond
            }
        })
    }
    handleClick(){
        window.location.href = '/supervipintro/open_member?wk_from=supervip'
        this.popupHide()
    }
    render(){
        const {show,remainingTime} = this.state
        const {lastThreeDay} = this.props
        return(
            <div>
                {
                    show &&
                    <div className='only-last-day'>
                        <div className="mask"></div>
                        <div className='pop-box'>
                            <div className="close" onClick={this.popupHide}><img src="https://static-cos.lycheer.net/xupload/20180731_close.png" alt=""/></div>
                            <div className="head-box" style={{backgroundImage:'url(https://static-cos.lycheer.net/xupload/20180731_pop-top.png)'}}>
                                <div>
                                    <p className='tit-icon'><img src="https://static-cos.lycheer.net/xupload/20180731_star-3.png" alt=""/></p>
                                    <p className='head-tit head-tit1'>会员有效时间不足{lastThreeDay}天</p>
                                </div>
                            </div>
                            <div className="main-box">
                                <div className="discount">立即续费，立减¥100</div>
                                <div className="big only-pay">180天仅需 ¥99</div>
                                <div className="big down-time">优惠倒计时 <span>{remainingTime.hour}</span>:<span>{remainingTime.minute}</span>:<span>{remainingTime.second}</span>.<span>{remainingTime.millisecond}</span></div>
                                <div className="pay-btn">
                                    <span onClick={this.handleClick}>立即续费</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <Pay/>
            </div>
        )
    }
}


class SuperVipPage extends React.Component {

    constructor() {
        super();
        this.timer = null;
        this.state = {
            init:false,
            isSuperVip: false,
            lastThreeDay:null,
            member: null,
            recommends: [],
            selectedList: {},
            new_goods:[],
            limit_money:null,
            rollTopNum:0,
            is_checked:false,
            bannerList:[
                {
                    'url':'https://mp.weixin.qq.com/s?__biz=MzU5MjU0OTg4Mg==&mid=100000472&idx=1&sn=106a7c5f511094fb47bff98468c51fc2&chksm',
                    'cover_url':'https://static-cos.lycheer.net/xupload/20180829_WechatIMG3.jpeg'
                },
                {
                    'url':"http://weike-member.keep.fm/activity/member_clock/",
                    'cover_url':'https://static-cos.lycheer.net/xupload/20180927_1000.png'
                }
            ]
        }
        this.getPageDataInit = this.getPageDataInit.bind(this)
        this.handleVipPay = this.handleVipPay.bind(this)
    }

    componentDidMount() {
        document.title = '会员专区'

        this.getPageDataInit();

        this.pageSetFromData();
    }
    componentWillUnmount(){
        this.timer && clearInterval(this.timer)
    }
    pageSetFromData(){
        let result = getJsonFromUrl();
        window.gio && window.gio("page.set", "superVipPageFrom",result.inviter_id||0);
    }
    getPageDataInit(){
        this.timer && clearInterval(this.timer)
        let result = getJsonFromUrl()
        let data = {}
        if (result.pt) {
            data.pt = result.pt
        } else {
            data.pt = 'recommend'
        }
        if (result.st) {
            data.st = result.st
        }
        if (result.inviter_id) {
            if(!(!isProduction && (+result.inviter_id === 64469671 || +result.inviter_id === 64469735))){
                data.inviter_id = result.inviter_id
            }
        }
        data.num = Math.random()
        //清空会员信息,倒计时刷新接口
        this.setState({
            isSuperVip: false,
            member: null,
            lastThreeDay:null,
            init:false,
            rollTopNum:0
        })
        axios.get('/api/member/recommends', {
            params: data,
        })
        .then((res) => {
            if(res.data.code === 0) {
                const data = res.data;
                if(data.data.member) {
                    let lastThreeDay = Math.ceil((data.data.member.expire_timestamp - new Date().getTime()/1000)/86400);
                    this.setState({
                        isSuperVip: true,
                        member: data.data.member,
                        lastThreeDay:lastThreeDay
                    });
                    this.localStorageexpireTime(data.data.member.expire_timestamp)
                }else {
                    localStorage.getItem("member_expire_timestamp")&& localStorage.removeItem("member_expire_timestamp");
                }
                let newList = this.bannerAddList(data.data.recommends[0],this.state.bannerList);
                this.setState({
                    limit_money:data.data.limit_money,
                    recommends: data.data.recommends,
                    selectedList: newList,
                    init:true,
                    new_goods:data.data.new_goods,
                    is_checked:data.data.is_checked
                },()=>{
                    data.data.recommends.length>=5 && this.rollingTags();
                    newList.records.length > 2 && newList.records[2].bannerList && newList.records[2].bannerList.length >=2 && this.bannerRolling(newList.records[2].bannerList)
                })

                //微信分享sdk
                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: data.data.share_info.share_title,
                        desc: data.data.share_info.share_description,
                        imgUrl: data.data.share_info.share_icon,
                        type: 'link',
                        link: data.data.share_info.share_url,
                    }
                });
            }
        })
    }

    localStorageexpireTime(expireTime){
        //存储过期时间
        let timestamp = JSON.parse(localStorage.getItem("member_expire_timestamp"));
        const lastThreeDay = this.state.lastThreeDay;
        let data = {
            show:true,
            day:lastThreeDay,
            expireTime:expireTime
        }
        if(timestamp){
            if(expireTime !== timestamp.expireTime && lastThreeDay && lastThreeDay <= 3){
                localStorage.setItem("member_expire_timestamp",JSON.stringify(data));
            }else {
                if(lastThreeDay <= 0 || lastThreeDay > 3){
                    localStorage.removeItem("member_expire_timestamp");
                }else{
                    if(lastThreeDay === timestamp.day){
                        data.show = false;
                        localStorage.setItem("member_expire_timestamp",JSON.stringify(data));
                    }else{
                        data.show =true;
                        localStorage.setItem("member_expire_timestamp",JSON.stringify(data));
                    }
                }
            }
        }else{
            if(lastThreeDay && lastThreeDay <= 3){
                localStorage.setItem("member_expire_timestamp",JSON.stringify(data));
            }
        }
    }

    sliceArr(array) {
        let result = [],end;
        if(array.length>5 && array.length<=8){
            end = 5
        }else{
            end = Math.ceil(array.length/2)
        }
        result.push(array.slice(0,end));
        result.push(array.slice(end,array.length));
        return result;
    }
    rollingTags(){
        /*设置滚动动画*/
        let style = document.createElement('style');
        style.type = 'text/css';
        let keyFrames = '\
            @-webkit-keyframes container {\
                0% {\
                    -webkit-transform: translate3d(0, 0, 0);\
                    transform: translate3d(0, 0, 0);\
                }\
                70% {\
                    -webkit-transform: translate3d(A_DYNAMIC_VALUE);\
                    transform: translate3d(A_DYNAMIC_VALUE);\
                }\
                100% {\
                     -webkit-transform: translate3d(0, 0, 0);\
                     transform: translate3d(0, 0, 0);\
                 }\
            }\
            @keyframes container {\
                0% {\
                    -webkit-transform: translate3d(0, 0, 0);\
                    transform: translate3d(0, 0, 0);\
                }\
                70% {\
                    -webkit-transform: translate3d( A_DYNAMIC_VALUE);\
                    transform: translate3d(A_DYNAMIC_VALUE);\
                }\
                100% {\
                         -webkit-transform: translate3d(0, 0, 0);\
                     transform: translate3d(0, 0, 0);\
                 }\
            }\
            #container{\
                animation: A_SPEED container normal;\
                position: relative;\
            }';
        let boxW = document.querySelector("#container .row0").offsetWidth;
        let SW = document.querySelector("#container").offsetWidth;
        let NUM_DYNAMIC = (SW - boxW + 8) + 'px,0,0'
        style.innerHTML = keyFrames.replace(/A_DYNAMIC_VALUE/g, NUM_DYNAMIC).replace(/A_SPEED/g, "1s");
        document.getElementsByTagName('head')[0].appendChild(style);
    }
    bannerRolling(list){
        let dataHeight = document.querySelector('.banner-a').offsetHeight + 10// 一份数据的高度

        document.querySelector('.banner-box').innerHTML += document.querySelector('.banner-box').innerHTML

        let rollTopNum = 0

        this.timer = setInterval(()=>{
            rollTopNum += -dataHeight;
            if(rollTopNum < -dataHeight*list.length){
                rollTopNum = 0;
                this.setState({
                    rollTopNum:rollTopNum
                },()=>{
                    setTimeout(()=>{
                        rollTopNum = -dataHeight
                        this.setState({
                            rollTopNum:-dataHeight
                        })
                    },10)
                })
            }else{
                this.setState({
                    rollTopNum:rollTopNum
                })
            }
        },3000)
    }
    handleVipPay() {
        location.href = '/supervipintro/open_member?wk_from=supervip';
    }
    handleTagsClick(e,item){
        if(item.name !== '热门推荐'){
            this.timer && clearInterval(this.timer);
        }
        let container = document.querySelector('.recommends__container');
        container.scrollLeft = e.clientX + container.scrollLeft - (document.documentElement.clientWidth / 2) + 20;
        this.setState({selectedList: item,rollTopNum:0},()=>{
            item.records.length > 2 && item.records[2].bannerList && item.records[2].bannerList.length >=2 && this.bannerRolling(item.records[2].bannerList)
        })
    }
    bannerAddList(item,bannerList){
        item.records.length > 2 && !item.records[2].itemName? item.records.splice(2,0,{
            itemName:'banner',
            bannerList:bannerList
        }):item.records;
        return item
    }
    bannerHtml(arr,index){
        const {rollTopNum} = this.state;
        return(
            <div className="banner" key={index}>
                <div className={rollTopNum === 0?'banner-box':'banner-box banner-box-roll'} style={{top:rollTopNum}}>
                    {
                        arr.map((item,i)=>{
                            return (
                                <a href={item.url} className="banner-a" key={i} style={{backgroundImage:`url(${item.cover_url})`}}></a>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
    render() {

        const {isSuperVip,member, selectedList,recommends,init,limit_money,lastThreeDay,is_checked} = this.state;
        const {nickname,avatar_url} = this.props.account;
        const localStorageMember = JSON.parse(localStorage.getItem("member_expire_timestamp"));
        if(!init){
            return (
                <div style={{backgroundColor:'#fff',height:'100vh'}}>
                    <Toast icon="loading" show={true}>加载中...</Toast>
                </div>
            )
        }
        return (
            <Page>
                <div className="superVipPage" >
                    <a className='superVipPage--headBox' href='/supervipintro/open_member?wk_from=supervip'>
                        <div className="head-box ">
                            <div className="left">
                                <div className="avatar_url"><img src={avatar_url} alt=""/></div>
                                <div className="vatar--info">
                                    {
                                        !isSuperVip && <p className='top-box'>加入超级会员</p>
                                    }
                                    {
                                        isSuperVip &&
                                        <p className='top-box'>
                                            <span className='nickname'>{nickname}</span><img src="https://static-cos.lycheer.net/xupload/20180706_vip_icon.png" alt=""/>
                                        </p>
                                    }
                                    <p className="bottom-box">
                                        {
                                            !isSuperVip?'每天不到6毛钱，畅听100+精品课':lastThreeDay > 3?`有效期至${TimeStream(member.expire_timestamp, 'YMD')}`:`剩余${TimeStream(member.expire_timestamp, '-H')}小时体验到期`
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className="right">
                                {
                                    !lastThreeDay && <img className='arrow-r' src="https://static-cos.lycheer.net/xupload/20180903_Chevron.png" alt=""/>
                                }
                                {
                                    lastThreeDay && lastThreeDay <= 3 && <span className="renew">立即续费 立减¥100</span>
                                }
                            </div>
                        </div>
                    </a>

                    {   /*new_goods && new_goods.length != 0 &&
                    <div className="recent-updates">
                        <div className="title">最近上新<a href='/supervipintro/updates' className='see-all'>查看全部</a></div>
                        <div className="list-box">
                            {
                                new_goods.map((item, index) => {
                                    const day = Math.floor(((new Date(new Date().setHours(0, 0, 0, 0) - item.create_date * 1000)).getTime()) / 1000 / 3600 / 24);
                                    return (
                                        <a href={`/channel/${item.id}/?from_svip_page=1`} className='item' key={index}>
                                            <span className='tit'>{item.promotion_word || item.name}</span>
                                            <span className='time'>{day === 0?'今天':day+'天前'}</span>
                                        </a>
                                    )
                                })
                            }
                        </div>
                    </div>*/
                    }
                    {
                        /*bannerList.length >= 1 && this.bannerHtml(bannerList,0)*/
                    }
                    <div className="recommends__list-title">
                        会员精品课
                    </div>
                    <div className="recommends__container">
                        {
                            recommends.length <= 5 &&
                            <div id="container">
                                <div className="row row0">
                                    {
                                        recommends.map((item, index) => {
                                            return (
                                                <div key={`tag__${index}`} className={selectedList.name === item.name ? 'recommends__tags recommends__tags-active' : 'recommends__tags'} onClick={(e)=>this.handleTagsClick(e,item)}>
                                                    {item.name}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                        {
                            recommends.length >5 &&
                            <div id="container">
                                {this.sliceArr(recommends).map((ele, i) => {
                                    return (
                                        <div className={`row row${i}`} key={i}>
                                            {ele.map((item,index)=>{
                                                return(
                                                    <div key={`tag__${index}`} className={selectedList.name === item.name ? 'recommends__tags recommends__tags-active' : 'recommends__tags'} onClick={(e)=>this.handleTagsClick(e,item)}>
                                                        {item.name}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </div>
                    {
                        selectedList.records && selectedList.records.map((ele,index) =>
                            ele.itemName === 'banner'?
                                this.bannerHtml(ele.bannerList,index)
                                : <SuperVipChannelList key={index} content={ele}></SuperVipChannelList>
                        )
                    }
                    <div className="member-clock-box">
                        <a className="member-clock" id='member-clock' href="http://weike-member.keep.fm/activity/member_clock/">
                            {
                                !is_checked &&  <span className="red"></span>
                            }
                            <img src="https://static-cos.lycheer.net/xupload/20180927_member_clock.png" alt=""/>
                        </a>
                    </div>
                </div>
                {
                    member && lastThreeDay && localStorageMember && localStorageMember.show && <OnlyThreeDayPopup expire_timestamp={member.expire_timestamp} lastThreeDay={lastThreeDay} money = {renderMoney(limit_money).split(".")[0]} refreshPage = {this.getPageDataInit} handlePayClick={this.handleVipPay} />
                }
                <div className="super-vip-page-popup-guide">
                    <img src={pgy} className="popup-content"/>
                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    account: state.account
}))(SuperVipPage)



// WEBPACK FOOTER //
// ./src/pages/SuperVipPage.js